import { createSelector } from 'reselect';

export const gameOverScenarios = {
    WINNER_LOSER: 'WINNER_LOSER',
    END_IN_TIE: "END_IN_TIE",
    END_IN_TIEBREAKER: "END_IN_TIE_BREAKER",
    ACTIVE_TIEBREAKER: "ACTIVE_TIEBREAKER"
}
const getTeams = (state) => {
    return state.gameOver?.teams;
};

const getAbstractGameCode = (state) => {
    return state.gameOver?.abstractGameCode;
}

const getTeamNameLabels = ({winner, loser, scenario}, teams = {}) => {
    const teamWinner = teams[winner];
    const teamLoser = teams[loser]
    const hasWinner = scenario === gameOverScenarios.WINNER_LOSER || scenario === gameOverScenarios.END_IN_TIEBREAKER
    return hasWinner ?
    {
        winnerFullName: teamWinner?.name || '',
        winnerTeamName: teamWinner?.teamName || '',
        winnerFranchiseName: teamWinner?.franchiseName || '',
        winnerShortName: teamWinner?.shortName || '',
        winnerAbbreviation: teamWinner?.abbreviation || '',
        loserFullName: teamLoser?.name || '',
        loserTeamName: teamLoser?.teamName || '',
        loserFranchiseName: teamLoser?.franchiseName || '',
        loserShortName: teamLoser?.shortName || '',
        loserAbbreviation: teamLoser?.abbreviation || ''
    } : {}
};

const getGameOverScenario = (state) => {
    const {
        runsHome,
        runsAway,
        awayIsWinner,
        homeIsWinner,
        currentInning,
        scheduledInnings,
        inningState,
        statusCode,
        abstractGameCode,
        tiebreakerScenario
         } = state.gameOver;
    let winner, loser, scenario;
    if (abstractGameCode === 'F'){
        // no tie, winner + loser
        if (runsAway > runsHome) {
            winner = 'away';
            loser = 'home';
            scenario = gameOverScenarios.WINNER_LOSER;
        } else if (runsHome > runsAway) {
            winner = 'home';
            loser =  'away';
            scenario = gameOverScenarios.WINNER_LOSER;
        }
        // ends in tie
        if (runsAway === runsHome && scheduledInnings === currentInning && statusCode === 'FT') {
            winner = 'TIE';
            loser = 'TIE';
            scenario = gameOverScenarios.END_IN_TIE;
        }
        // ends after tiebreaker
        if (statusCode === 'FW' || statusCode === 'OW') {
            scenario = gameOverScenarios.END_IN_TIEBREAKER;
            if (awayIsWinner) {
                winner = 'away';
                loser = 'home';
            } else if (homeIsWinner){
                winner = 'home';
                loser = 'away';
            }
        }
    } else if (abstractGameCode === 'L'){
        // tiebreaker active
        if (runsAway === runsHome && ((scheduledInnings === currentInning && inningState === 'End') || scheduledInnings < currentInning) && !!tiebreakerScenario) {
            scenario = gameOverScenarios.ACTIVE_TIEBREAKER;
        }
    }
    return { winner, loser, scenario };
}

const getTiebreakerInfo = (state) => {
    const tiebreaker = state?.gameOver?.tiebreakerScenario;
    const xrefId = state?.gameOver?.xrefId;
    return {...tiebreaker, xrefId}
}

// reselect function
export const getGameOverState = createSelector(
    [getTeams, getAbstractGameCode, getGameOverScenario, getTiebreakerInfo],
    (teams, abstractGameCode, gameOverScenario, tiebreakerInfo) => {
        return {
        teamNameLabels: getTeamNameLabels(gameOverScenario, teams),
        abstractGameCode,
        gameOverScenario,
        tiebreakerInfo
        }
    }
);
